import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[formControlName], input[formControl], input[ngModel], textarea[formControlName], textarea[formControl], textarea[ngModel]',
  standalone: true,
})
export class TrimWhitespaceDirective {

  constructor(@Optional() private ngControl: NgControl) {}

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement | null;
    if (!target) return;

    // Skip trim for password, file, and other non-text inputs
    if (target instanceof HTMLInputElement) {
      const skipTypes = ['password', 'file', 'checkbox', 'radio', 'range', 'color', 'hidden'];
      if (skipTypes.includes(target.type?.toLowerCase())) return;
    }

    const value = target.value ?? '';
    const trimmed = value.trim();

    if (value !== trimmed) {
      // Always update the DOM value directly first
      target.value = trimmed;

      if (this.ngControl?.control) {
        // Dispatch a native input event so Angular DefaultValueAccessor picks up
        // the change through its normal onChange() pipeline — works with OnPush
        target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }
}
